module.exports = __webpack_public_path__ + "img/bg_park.c56e9865.jpg";